// Sanctions overlay — OFAC / EU / UN designations as MIL-STD-2525 hostile
// frames (square) tinted by severity.

import type { intel as i } from '@eidollon/contracts';
import { buildIconLayer } from './_icon-builder.js';
import { withGeom } from './_shared.js';
import type { LayerSpec } from './registry.js';

const TYPES: readonly i.SignalType[] = ['SAN'];
const TYPE_SET = new Set<i.SignalType>(TYPES);

export const sanctionsLayer: LayerSpec = {
  id: 'sanctions',
  label: 'SAN · sanctions',
  kind: 'icon',
  signalTypes: TYPES,
  color: 'var(--red)',
  colorAxis: 'category',
  description: 'OFAC + EU + UN sanctions designations',
  classification: 'OPEN',
  legend: {
    swatch: 'var(--red)',
    label: 'SAN',
    hint: 'OFAC / EU / UN sanctions add+remove',
  },
  select: (rows) => withGeom(rows).filter((r) => TYPE_SET.has(r.signal_type)),
  // Always visible — the feed is capped at ~200 rows so there is no clutter,
  // and a single-type filter must show that type at ANY zoom (otherwise the
  // map goes empty below the old threshold). See route bug: "toggle on -> disappear".
  visibleAtZoom: () => true,
  deckLayer: ({ rows, viewport, onPick }) => {
    const data = withGeom(rows).filter((r) => TYPE_SET.has(r.signal_type));
    return buildIconLayer({
      id: 'intel-sanctions',
      rows: data,
      zoom: viewport.zoom,
      sizeMin: 12,
      sizeMax: 28,
      onPick,
    });
  },
};
